'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userTypes = require('../../constants/userTypes');

var _userTypes2 = _interopRequireDefault(_userTypes);

var _accountTypes = require('../../constants/accountTypes');

var _accountTypes2 = _interopRequireDefault(_accountTypes);

var _userStatus = require('../../constants/userStatus');

var _userStatus2 = _interopRequireDefault(_userStatus);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Usage:
 * const isUser = new IsUser(userType);
 * (isUser.investor || isUser.issuer) 
 *  && isUser.userAccount
 *  && !isUser.na
 *  && renderSomething()
 */


var IsUser =
/**
 * @param status - String
 * @param accountType - String
 * @param userType - String
 */
function IsUser(userType, accountType, status) {
  _classCallCheck(this, IsUser);

  //user type
  this.issuer = userType === _userTypes2.default.ISSUER;
  this.investor = userType === _userTypes2.default.INVESTOR;
  this.adminSP = userType === _userTypes2.default.ADMIN_STRATEGIC_PARTNER;
  this.workerSP = userType === _userTypes2.default.WORKER_STRATEGIC_PARTNER;
  this.issuerSP = userType === _userTypes2.default.ISSUER_STRATEGIC_PARTNER;
  this.investorSP = userType === _userTypes2.default.INVESTOR_STRATEGIC_PARTNER;
  this.otherSP = userType === _userTypes2.default.OTHER_STRATEGIC_PARTNER;
  this.COSP = userType === _userTypes2.default.COMPLIANCE_OFFICER_STRATEGIC_PARTNER;
  this.advisor = userType === _userTypes2.default.ADVISOR;
  this.superAdmin = userType === _userTypes2.default.SUPER_ADMIN;
  this.allSP = /STRATEGIC_PARTNER/g.test(userType);
  this.allIssuers = /ISSUER/g.test(userType);
  this.allInvestors = /INVESTOR/g.test(userType); //account type

  this.userAccount = accountType === _accountTypes2.default.USER;
  this.companyAccount = accountType === _accountTypes2.default.COMPANY; //status

  this.na = status === _userStatus2.default.NA;
  this.applied = status === _userStatus2.default.APPLIED;
  this.registered = status === _userStatus2.default.REGISTERED;
  this.invited = status === _userStatus2.default.INVITED;
  this.confirmed = status === _userStatus2.default.CONFIRMED;
  this.userDataFilled = status === _userStatus2.default.USER_DATA_FILLED;
  this.cvAdded = status === _userStatus2.default.CV_ADDED;
  this.signed = status === _userStatus2.default.SIGNED;
  this.kycPassed = status === _userStatus2.default.KYC_PASSED;
  this.accountCreated = status === _userStatus2.default.ACCOUNT_CREATED;
  this.kycDocumentAdded = status === _userStatus2.default.KYC_DOCUMENT_ADDED;
  this.kycDocumentValidated = status === _userStatus2.default.KYC_DOCUMENT_VALIDATED;
  this.paymentMethodAdded = status === _userStatus2.default.PAYMENT_METHOD_ADDED;
  this.waitingForWalletReplenishment = status === _userStatus2.default.WAITING_FOR_WALLET_REPLENISHMENT;
  this.walletFilled = status === _userStatus2.default.WALLET_FILLED;
  this.subscriptionBought = status === _userStatus2.default.SUBSCRIPTION_BOUGHT;
  this.complianceOfficerAdded = status === _userStatus2.default.COMPLIANCE_OFFICER_ADDED;
};

exports.default = IsUser;